$.formUtils.addValidator({
	name : 'email',
	validatorFunction : function(val, $el, conf) {
		var actualValue = $el.val(); // needed because validator framework trims the 'value' argument
		if('' != actualValue){
			var emailParts = actualValue.toLowerCase().split('@');
			if( emailParts.length == 2 ) {
				return $.formUtils.validators.validate_domain.validatorFunction(emailParts[1]) && !(/[^\w\+\.\-]/.test(emailParts[0]));
			}
			return false;
		} else {
			return true;
		}
	},
	errorMessage : 'This field is not a valid email',
	errorMessageKey: 'badEmail'
});
